import {
    BASKET_SCOPE_DEV,
    BASKET_SCOPE_PROD,
    BASKET_SCOPE_QA,
    DEFAULT_POLICY,
    OAuthTokenScopes,
    WZ_SCOPE_DEV,
    WZ_SCOPE_PROD,
    WZ_SCOPE_QA,
} from '@os-components';

export const authDev: OAuthTokenScopes = {
    clientId: 'b96ccfbb-3a86-4617-9f89-ab016c76771d',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_DEV, WZ_SCOPE_DEV],
};
export const authQa: OAuthTokenScopes = {
    clientId: '6b8e4d6f-043d-4527-8c8a-e6a03824e6a5',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_QA, WZ_SCOPE_QA],
};

// TODO Ändern mit richtige wenn es gibt prod auth scope
export const authProd: OAuthTokenScopes = {
    clientId: '',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_PROD, WZ_SCOPE_PROD],
};

// export const href = '/os/basket/';
// export const path = '/os/api/basket';
